import { NgModule } from '@angular/core';
import { MsColorPickerComponent } from './ms-color-picker.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsColorPickerComponent],
	imports: [SharedLibsModule],
	exports: [MsColorPickerComponent],
	providers: [],
})
export class MsColorPickerModule {}
